import { createAsyncThunk } from "@src/store";
import {
  selectedCurrentCustomEvent,
  setCustomEventSelectedProducts,
  setCustomEventSelectedProductsLoading,
} from "@src/store/slices/customEvents";
import { loadSelectedProducts } from "@src/store/slices/productPicker/util/loadSelectedProducts";

export const loadCustomEventSelectedProducts = createAsyncThunk<void, void>(
  "customEvents/loadCustomEventSelectedProducts",
  async (_, { dispatch, getState }) => {
    const customEvent = selectedCurrentCustomEvent(getState());
    dispatch(setCustomEventSelectedProducts([]));

    if (customEvent?.type === "productPageView") {
      const ids = customEvent.settings
        .filter((s) => s.productId)
        .map((s) => s.productId);
      if (ids.length > 0) {
        dispatch(setCustomEventSelectedProductsLoading(true));

        const products = await loadSelectedProducts(ids);

        dispatch(setCustomEventSelectedProducts(products));
        dispatch(setCustomEventSelectedProductsLoading(false));
      }
    }
  }
);
